module.exports = __webpack_public_path__ + "img/faq.8e0b3142.jpg";